import React from 'react';

import PropTypes from 'prop-types';
import { chekIsSpentAcc, getAccumulatorInfo } from 'utils/accumulators';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const AccumulatorInfo = ({ acc }) => {
  const isSpent = chekIsSpentAcc(acc);
  const accInfo = getAccumulatorInfo(acc);

  return (
    <div className={cx('accumulator', { disabled: isSpent })}>
      <span className={cx('accumulatorValue')}>{accInfo.value}</span>
      <span className={cx('accumulatorUnit')}>{accInfo.unit}</span>
    </div>
  );
};

AccumulatorInfo.propTypes = {
  acc: PropTypes.shape({
    rest: PropTypes.number,
    unit: PropTypes.string,
  }),
};

export default AccumulatorInfo;
